import { AbilityBuilder, createMongoAbility } from "@casl/ability";

export default function defineAbilityFor() {
  const { build } = new AbilityBuilder(createMongoAbility);
  return build();
}
